<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('shopd.otitle') }}
      </div>
      <!-- <div class="top_right" @click="$router.push('/moneybag')">
				<van-icon name="bars" size="25"/>
			</div> -->
    </div>
    <div class="head-tabs">
      <a
        href="#/ordering"
        class="tab-item "
      >{{ $t('shopd.Ordering') }}</a>
      <a
        href="#/ordered"
        class="tab-item active"
      >{{ $t('shopd.done') }}</a>
    </div>
		
    <!-- 	<h3 class="notes_tit">{{$t('shopd.ordered')}}</h3> -->
    <van-empty
      v-if="empty"
      :description="$t('orders.noOrders')"
    />
		
    <div class="record-list">
      <div
        v-for="i in data"
        v-if="!empty"
        class="record-line"
      >
        <div class="container-full flex-row-between record-tools">
          <div class="tools-left">
            {{ formatBrowserTime(i.ct) }}
          </div>
          <div class="flex-row-left tools-right">
            <div class="tools-status1">
              <span>{{ $t('shopd.done') }}</span>
            </div>
          </div>
        </div>
        <div class="container-full record-content">
          <div class="flex-row-left record-top">
            <img
              class="goods-image"
              :src="app?.domain+'/'+i.pic"
            >
            <div class="goods-intro">
              <div class="goods-name">
                {{ i.title }}
              </div>
              <div class="goods-name-line">
                <span class="goods-name-label">{{ i.desc }}</span>
                <span class="goods-name-value" />
              </div>
              <div class="goods-name-line">
                <span class="goods-name-label">Booking Days:</span>
                <span class="goods-name-value">{{ i.num }}</span>
                <span class="goods-name-label">Days</span>
              </div>
            </div>
          </div>
          <div class="container-full flex-row-left record-bottom">
            <div class="total-amount">
              <div class="amount-name">
                {{ $t('shopds.money') }}
              </div>
              <div class="amount-value">
                <span class="amount-unit">{{ utils_moneyMark() }}</span>
                <span class="amount-text">{{ i.price }}</span>
              </div>
            </div>
            <div class="total-amount">
              <div class="amount-name">
                {{ $t('shopds.income') }}
              </div>
              <div class="amount-value">
                <span class="amount-unit">{{ utils_moneyMark() }}</span>
                <span class="amount-text">{{ i.fee }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
		
    <!-- <div  class="order_list1" v-if="!empty" v-for="i in data">
		    <div  class="list_top1">
		        <img :src="i.pic" />
		        <div  class="list_text1">
		            <span>{{i.title}}</span>
		            <div>
		                <p >{{i.price}}</p>
		                <p >X1</p>
		            </div>
		        </div>
		    </div>
		    <div  class="list_down1">
		        <div  class="list_down">
					<div >
					    <span>{{$t('shopds.onum')}}</span>
					    <span>{{i.no}}</span>
					</div>
		            <div >
		                <span>{{$t('shopds.time')}}</span>
		                <span>{{ formatBrowserTime(i.ct) }}</span>
		            </div>
		           
		            <div >
		                <span>{{$t('shopds.money')}}</span>
		                <span>{{i.price}}</span>
		            </div>
		            <div >
		                <span>{{$t('shopds.numtask')}}</span>
		                 <span>{{i.level}}</span>
		            </div>
					<div >
		               <span>{{$t('shopds.income')}}</span>
		               <span  style="color: rgb(255, 83, 83);">{{i.fee}}</span>
		           </div>
		        </div>
		    </div>
		</div> -->
		
		
		
		
		
		
    <!-- <a class="continue" v-if="!empty" v-for="i in data">
		    <div class="box order">
		        <div class="header1">
		            <div class="id">{{i.no}}</div>
		            <div class="time">{{ formatBrowserTime(i.ct) }}</div>
		        </div>
		        <div class="content">
		            <div class="left"><img :src="i.pic"></div>
		            <div class="right">
		                <div class="title">
							{{i.title}}
		                </div>
		                <div class="price">{{$t('shopd.total')}} : <em>$ {{i.price}}</em></div>
		                <div class="earnings">{{$t('shopd.commission')}} : <em>$ {{i.fee}}</em></div>
		            </div>
		        </div>
		    </div>
		</a>
		<div class="scrollBox">
			<div class="notes_box invest" v-if="!empty" v-for="i in data.list">
				<p class="timer">
					<span style="font-size: 16px;color: #333333;font-weight: bold;">
					{{i.id}}
					</span>
					<span class="item_btn" v-if="i.isling==1" style="height: 30px;text-align: center;varticle-align:middle;border-radius: 5px;background-color:green; ">
						<button type="button" style="line-height: 20px;padding: 0px 10px;color: #FFFFFF;" @click="receiveRewards(i)">{{$t('utils.receiveRewards')}}</button>
					</span>
					<span class="item_btn" v-if="i.isling==0" style="height: 30px;text-align: center;varticle-align:middle;border-radius: 5px;background-color: #a8aebb; ">
						<button type="button" style="line-height: 20px;padding: 0px 10px;color: #FFFFFF;">{{$t('utils.receiveRewards')}}</button>
					</span>
				</p>
			</div>
		</div> -->
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty
	} from "vant";
    var _that;
	import {
		Dialog
	} from 'vant';
	import Fetch from "../../utils/fetch";
	Vue.use(Empty);
	export default {
		name: "Ordered",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				app: null,
				data: null,
				empty: false,
			};
		},
		created() {
			this.$parent.footer("ordering");
		},
		mounted() {
			this.start();
			_that = this;
		},
		methods: {
			start() {
				Fetch("/user/ordered").then((r) => {
					this.data = r.data;
					r.data.length == 0 ?
						(this.empty = true) :
						(this.empty = false);
				});
				Fetch('/index/webconfig').then((r)=>{
					this.app = r.data;
				});
			}
		},
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		
	}

	.money_box {
		display: flex;
		justify-content: space-around;
		border-radius: 10px;
		padding: 10px;
		margin: 10px;
		color:#36333d;
		background: #FFF;

		.item {
			width: 33.33%;
			text-align: center;
			font-weight: bold;

			.money_num {
				font-size: 18px;
				line-height: 25px;
				white-space: normal;
				word-break: normal;
				text-align: center;
			}

			.info {
				font-size: 12px;
				line-height: 20px;
				font-weight: normal;
				margin-top: 5px;
			}
		}
	}

	.notes_tit {
		line-height: 44px;
		height: 44px;
		font-size: 14px;
		color: #000000;
		padding: 0 14px;
		background: #FAFAFA;
		z-index: 2;
		margin: 10px;
		border-radius: 5px;
	}

	.notes_box {
		width: 100%;
		padding-bottom: 2px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 6px;
		margin-bottom: 10px;

		.timer {
			padding: 3px 3px;
			font-size: 12px;
			color: rgba(0, 0, 0, .6);
			border-bottom: 1px solid #ececec;
			display: flex;
			justify-content: space-between;
			align-items: center;

			span {
				font-style: normal;
				padding: 5px;
				border-radius: 5px;
				color: #FFFFFF;
			}

			.ing {
				background: #3775f4;
			}

			.finish {
				font-style: normal;
				background: #07c160;
			}
		}

		.item_div1 {
			display: flex;
			justify-content: space-between;
			padding: 15px 10px;

			p:nth-child(1) {
				width: 100%;
				font-weight: bold;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;

			}
		}

		.item_div2 {
			display: flex;
			justify-content: space-between;
			text-align: center;
			margin-bottom: 5px;
			margin-top: 5px;
			div {
				width: 33.33%;

				p {
					padding: 5px 0;
				}
			}

			.item_rate {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;
					color: #FF0000;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_day {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_min {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;

				}

				p:nth-child(2) {
					color: #999;
				}
			}
		}
	}

	.scrollBox {
		width: 96%;
		margin-left: 2%;
	}
	
	.head-tabs {
	    height: 50px;
	    padding: 15px;
	    background: #FFF;
	    white-space: nowrap;
		border-radius: 10px;
		text-align: center;
		margin: 10px;
		.tab-item {
		    z-index: 0;
		    position: relative;
		    height: 16px;
		    line-height: 16px;
		    font-size: 14px;
		    color: #37475a;
		    transition: all .3s ease;
		}
		.tab-item:after {
		    z-index: -1;
		    content: "";
		    position: absolute;
		    left: 0;
		    right: 0;
		    bottom: 0;
		    height: 4px;
		    border-radius: 2px;
			
		}
		.active {
		    font-size: 1.3em;
		    color: #ee264d;;
			:after {
			    background: #ff8c46;
			}
		}
		.tab-item.active:after {
		    background: #ff8c46;
		}
		.tab-item+.tab-item {
		    margin-left: 20px;
		}
	}
	
	.box {
		margin: 3vw;
		border-radius: 2vw;
		overflow: hidden;
	    background-color: rgb(12, 109, 86);
		padding: 0;
		color: #FFF;
		.header1 {
		    display: flex;
		    padding: 0 10px;
		    height: 40px;
		    line-height: 40px;
		    font-size: 14px;
			background: none;
			border-bottom: none;
			color: #FFF;
			.id {
			    font-weight: bold;
				color: #FFF;
			}
			.time {
			    flex: 1;
			    text-align: right;
			    color: #999;
			    font-size: 10px;
				color: #FFF;
			}
		}
		.content {
		    display: flex;
		    padding: 0 10px 10px;
			.left {
			    border-radius: 3vw;
			    width: 90px;
			    height: 90px;
			    padding: 2px;
			    text-align: center;
			    background-color: #75777a;
			    overflow: hidden;
				img {
				    border-radius: 3vw;
				    width: 90px;
				    height: 90px;
				}
			}
			.right {
			    position: relative;
			    flex: 1;
			    padding-left: 10px;
			    line-height: 20px;
				.title {
				    margin-bottom: 10px;
				    height: 40px;
				    font-weight: 500;
				    overflow: hidden;
				}
				 .price,.earnings {
				    color: #aaa;
					 em {
						font-style: normal;
						font-size: 16px;
						font-weight: bold;
						color: #e5ae2f;
					}
				}
			}
			.button {
			    display: block;
			    padding: 0 10px;
			    border-radius: 5px;
			    height: 40px;
			    line-height: 40px;
			    font-size: 18px;
			    color: #202226;
			    text-align: center;
			    background: linear-gradient(180deg, #36333d, #746b0a);
			    overflow: hidden;
			    cursor: pointer;
			}
		}
	}
	.order_list1{
	    background-color: #fff;
	    padding: 10px;
		margin: 10px;
	    border-radius: 10px;
	    box-shadow: 0 4px 4px rgba(0,0,0,.05);
		.list_top1{
		    width: 100%;
		    height: 90%;
		    border-bottom: 1px dashed gray;
		    display: flex;
		    justify-content: space-between;
		    padding: 5px 0;
			img{
			    max-width: 100px;
			    max-height: 100px;
			    border-radius: 10px;
			}
			.list_text1{
			    width: 100%;
			    margin-left: 10px;
			    display: flex;
			    justify-content: space-between;
			    flex-direction: column;
				> span:first-child {
				    display: block;
				    font-size: 12px;
				    color: #37475a;
				    overflow: hidden;
				    text-overflow: ellipsis;
				    -webkit-line-clamp: 4;
				    display: -webkit-box;
				    -webkit-box-orient: vertical;
					line-height: 1.5em;
				}
				 > div {
				    display: flex;
				    justify-content: space-between;
				    align-items: center;
				    margin: 3% 0;
				    color: #232f3e;
				    font-size: 17px;
				    font-weight: 600;
					> p:last-child {
					    color: #034aff;
					    font-size: 12px;
					}
				}
			}
		}
		.list_down{
		    /* height: 50%; */
		    display: flex;
		    flex-direction: column;
		    justify-content: space-between;
		    font-size: 13px;
		    padding: 5px 0;
			> div{
			    display: flex;
			    justify-content: space-between;
			    align-items: center;
			    color: #37475a;
			    height: 20px;
				> span:last-child {
				    color: #232f3e;
				    font-size: 13px;
				}
			}
		}
		.list_down1{
		    height: auto;
		    text-align: end;
			font-size: 16px;
		}
	}
	.record-list{
	    margin-top: 15px;
		padding: 0px 12px;
		.record-line{
			.container, .container-full {
			    box-sizing: border-box;
			    width: 100%;
			}
			.flex-row-between, .flex-row-between12 {
			    display: flex;
			    flex-direction: row;
			    justify-content: space-between;
			    align-items: center;
			}
			.tools-left{
			    font-weight: 700;
			    font-size: 10px;
			    line-height: 12px;
			}
			.flex-row-center, .flex-row-left {
			    display: flex;
			    flex-direction: row;
			    align-items: center;
			}
			.record-content {
			    background: #fff;
			    box-shadow: 0 2px 2px rgba(0,0,0,.1);
			    border-radius: 10px;
			    margin-bottom: 20px;
			    margin-top: 10px
			}
			
			.record-top {
			    display: flex;
			    flex-direction: row;
			    align-items: center;
			    box-sizing: border-box;
			    width: 100%;
			    padding: 15px;
			    border-bottom: .5px solid #7c7c7c
			}
			
			.goods-image {
			    width: 80px;
			    height: 80px;
				border-radius: 8px;
			}
			
			.goods-intro {
			    padding-left: 15px;
			    font-size: 14px
			}
			
			.goods-name {
			    font-weight: 700;
				font-size: 14px;
				line-height: 20px;
			}
			
			.goods-name-line {
			    margin-top: 5px;
				color: #333;
				font-size: 12px;
				line-height: 16px;
			}
			
			.goods-name-value {
			    padding-left: 5px;
			    padding-right: 3px
			}
			
			.record-bottom {
			    padding: 15px
			}
			
			.total-amount {
			    margin-right: 50px
			}
			
			.amount-name {
			    font-size: 10px;
			    line-height: 12px;
			    color: #aeaeae
			}
			
			.amount-value {
			    font-weight: 700;
			    margin-top: 6px;
			    font-size: 13px;
			    line-height: 16px;
			    color: #000
			}
			.tools-status1, .tools-status2 {
				color: #969799;
				border: 0.5px solid #969799;
				border-radius: 10px;
				box-sizing: border-box;
				height: 22px;
				line-height: 22px;
				font-size: 12px;
				padding: 0 10px;
				white-space: nowrap;
				font-weight: bold;
			}
			
		}
	}
</style>
